import React, { useEffect, useState } from "react";
// import MasterLayout from "../../masterLayout/MasterLayout";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../../components/Breadcrumb";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";
// import { BaseUrl } from "../../helper/apiHelper";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";
import { createBlogCategoryApi, createBlogTagsApi, deleteBlogcategoryApi, deleteBlogTagsApi, getBlogCategoriesApi, getBlogTagsApi } from "../helper/api_helper";
const BlogTags = () => {
    const [guards, setGuards] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showAddGuardModal, setShowAddGuardModal] = useState(false);
    const [newGuard, setNewGuard] = useState({ categoryName: '', id: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [isEditing, setIsEditing] = useState(false); // Track edit mode
    const [searchTerm, setSearchTerm] = useState("");

    const handleCreateOrUpdateGuard = async () => {
        const { categoryName, id } = newGuard;

        // if (!categoryName) {
        //     toast.error("Please fill all fields");
        //     return;
        // }

        if (!categoryName) {
            toast.error("Please fill all fields");
            return;
        }


        try {
            setIsLoading(true);

            if (isEditing) {


                const response = await createBlogTagsApi({
                    tag_name: categoryName,
                    id: id,
                })




                toast.success("Tag updated successfully!");
            } else {


                await createBlogTagsApi({
                    tag_name: categoryName,

                })
                toast.success("Tag created successfully!");
            }

            setShowAddGuardModal(false);
            setNewGuard({ categoryName: '', id: '' });
            setIsEditing(false);
            getAllBlogCategories(); // Refresh list
        } catch (error) {
            toast.error(error || "Action failed");
        } finally {
            setIsLoading(false);
        }
    };

    const handleGuardChange = (e) => {
        const { name, value } = e.target;
        setNewGuard((prev) => ({ ...prev, [name]: value }));
    };

    const [isLoading, setIsLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);

    const getAllBlogCategories = async () => {
        try {
            setIsPageLoading(true);
            const response = await getBlogTagsApi();

            setCategories(response.data);

        } catch (error) {

            toast.error("Failed to fetch categories");
            setCategories([]);
        } finally {
            setIsPageLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogCategories();
    }, []);
    const handleEditClick = async (item) => {

    }
    const handleDeleteClick = async (item) => {
        const toastId = toast.loading("Deleting Tag...");
        try {

            let body = { id: item.id }
            let response = await deleteBlogTagsApi(body);
            // if (response.status === 200) {
                toast.success("Tag deleted successfully", { id: toastId })
                getAllBlogCategories()
            // }
        } catch (error) {
            toast.error(error || "Something went wrong", { id: toastId });

        }
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const filteredBooking = categories?.filter((categories) => {
        const search = searchTerm?.toLowerCase();

        return Object.entries(categories)
            .filter(([key]) =>
                ["tag_name"].includes(key)
            )
            .some(([_, value]) =>
                String(value)?.toLowerCase().includes(search)
            );
    });


    const [currentPage, setCurrentPage] = useState(1);

    const [itemsPerPage] = useState(10);
    const totalItems = categories?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <MasterLayout>
            <Breadcrumb title="Tags Management" />

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                        <form className="navbar-search d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto form-control"
                                name="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>

                        <button
                            type="button"
                            className="btn btn-primary-600 radius-8 px-20 py-11"
                            onClick={() => {
                                setIsEditing(false); // Exit edit mode
                                setNewGuard({ categoryName: '', id: '' }); 
                                setShowAddGuardModal(true);
                            }}
                        >
                            + Add Tags
                        </button>

                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            {isPageLoading ? (
                                <div className="text-center py-40">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : filteredBooking?.length === 0 ? (
                                <div className="text-center py-40 text-muted fw-medium">No Tags found.</div>
                            ) : (
                                <table className="table basic-border-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Tag Name</th>
                                            {/* <th>Email</th> */}
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredBooking?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => (



                                            <tr key={index}>
                                                <td>{formatDate(items.createdAt)}</td>
                                                <td>{items.tag_name}</td>
                                                {/* <td>{items.email}</td> */}
                                                <td className="text-start">
                                                    <div className="d-flex align-items-start gap-10 justify-content-start">
                                                        <button
                                                            type="button"
                                                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => {
                                                                setIsEditing(true);
                                                                setShowAddGuardModal(true);
                                                                setNewGuard({

                                                                    categoryName: items.tag_name, // if not available, use placeholder
                                                                    id: items.id,
                                                                });
                                                            }}
                                                        >
                                                            <Icon icon="lucide:edit" className="menu-icon" />
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => handleDeleteClick(items)}
                                                            className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                        >
                                                            <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {filteredBooking?.length > itemsPerPage &&


                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                                <span>
                                    Showing {startIdx + 1} to{" "}
                                    {Math.min(startIdx + itemsPerPage, filteredBooking?.length)} of{" "}
                                    {filteredBooking?.length} entries
                                </span>
                                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            <Icon icon="ep:d-arrow-left" className="text-xl" />
                                        </button>
                                    </li>

                                    {[...Array(totalPages)].map((_, index) => (
                                        <li className="page-item" key={index}>
                                            <button
                                                className={`page-link ${currentPage === index + 1
                                                    ? "bg-primary-600 text-white"
                                                    : "bg-primary-50 text-secondary-light"
                                                    } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                                onClick={() => goToPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            <Icon icon="ep:d-arrow-right" className="text-xl" />
                                        </button>
                                    </li>
                                </ul>
                            </div>}


                    </div>
                </div>
                {/* card end */}
            </div>


            {showAddGuardModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div
                            className="modal-dialog modal-md modal-dialog-centered"
                            style={{ zIndex: 11122 }}
                        >
                            <div className="modal-content radius-16 bg-base">
                                <div className="modal-header py-16 px-24 border-bottom">
                                    <h1 className="modal-title fs-5">  {isEditing ? "Update Tag" : "Add Tag"}</h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAddGuardModal(false)}
                                    />
                                </div>

                                <div className="modal-body p-24">
                                    <form className="row g-3">

                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Tag Name</label>
                                            <input
                                                type="text"
                                                name="categoryName"
                                                placeholder="Enter Tag Name"
                                                className="form-control"
                                                value={newGuard.categoryName}
                                                onChange={handleGuardChange}
                                            />
                                        </div>


                                        <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                            <button
                                                type="button"
                                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-24 py-10 radius-8"
                                                onClick={() => {
                                                    setShowAddGuardModal(false);
                                                    setNewGuard({ categoryName: '', id: '' });
                                                    setIsEditing(false);
                                                }}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary border border-primary-600 text-md px-32 py-10 radius-8 d-flex align-items-center gap-2"
                                                onClick={handleCreateOrUpdateGuard}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" role="status" />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    isEditing ? 'Update' : 'Save'
                                                )}
                                            </button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Modal backdrop */}
                        <div
                            className="modal-backdrop fade show"
                            style={{ zIndex: 1040 }}
                        />
                    </div>
                </>
            )}

        </MasterLayout>
    );
};

export default BlogTags;
